var proto, map;
module.exports = proto = {};
map = typeof WeakMap === 'undefined' ? null : new WeakMap();
proto.get = !map ? no_weakmap_get : get;

function no_weakmap_get(target) {
  return new DataView(target.buffer, 0);
}

function get(target) {
  var out = map.get(target.buffer);

  if (!out) {
    map.set(target.buffer, out = new DataView(target.buffer, 0));
  }

  return out;
}